import $ from 'jquery';

(async () => {
    window.jQuery = window.$ = $;
})();
